import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";

const PurchaseEntry = () => {
    const navigate = useNavigate();
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const userData = sessionStorage.getItem("user");
    const userObj = userData ? JSON.parse(userData) : {};

    const [items, setItems] = useState([]);
    
    const [form, setForm] = useState({
        purchase_no: `PUR-${Date.now()}`,
        purchase_date: new Date().toISOString().split('T')[0],
        item_id: "",
        quantity: "",
        remarks: ""
    });

    useEffect(() => {
        fetchItems();
    }, []);

    const fetchItems = async () => {
        const res = await axios.post(baseUrl + "/inventoryitem/", { action: "READ", school_id: userObj.school_id });
        setItems(res.data || []);
    };

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.item_id) {
            toast.error("Please select an item");
            return;
        }
        
        try {
            const payload = {
                ...form,
                school_id: userObj.school_id,
                createdby: userObj.user_id,
                action: "CREATE"
            };
            await axios.post(baseUrl + "/inventorypurchase/", payload);
            toast.success("Purchase Recorded Successfully");
            setTimeout(() => navigate("/purchaselist"), 1500);
        } catch (error) {
            toast.error("Error saving purchase");
        }
    };

    return (
        <div className="pageBody">
            <ToastContainer />
            <Container fluid>
                <div className="">
                    <Card>
                        <Card.Body>
                            <Form onSubmit={handleSubmit}>
                                <Row>
                                    <Col xs={12}>
                                        <h6 className="commonSectionTitle">New Purchase Entry</h6>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} md={6} lg={4} xxl={3}>
                                        <div className="commonInput">
                                            <Form.Group>
                                                <Form.Label>Purchase No</Form.Label>
                                                <Form.Control name="purchase_no" value={form.purchase_no} readOnly />
                                            </Form.Group>
                                        </div>
                                    </Col>
                                    <Col xs={12} md={6} lg={4} xxl={3}>
                                        <div className="commonInput">
                                            <Form.Group>
                                                <Form.Label>Purchase Date</Form.Label>
                                                <Form.Control type="date" name="purchase_date" value={form.purchase_date} onChange={handleChange} />
                                            </Form.Group>
                                        </div>
                                    </Col>
                                    <Col xs={12} md={6} lg={4} xxl={3}>
                                        <div className="commonInput">
                                            <Form.Group>
                                                <Form.Label>Item <span className="requiredStar">*</span></Form.Label>
                                                <Form.Select name="item_id" value={form.item_id} onChange={handleChange} required>
                                                    <option value="">Select Item</option>
                                                    {items.filter(i => i.is_active === 'A').map(i => <option key={i.item_id} value={i.item_id}>{i.item_name}</option>)}
                                                </Form.Select>
                                            </Form.Group>
                                        </div>
                                    </Col>
                                    <Col xs={12} md={6} lg={4} xxl={3}>
                                        <div className="commonInput">
                                            <Form.Group>
                                                <Form.Label>Quantity <span className="requiredStar">*</span></Form.Label>
                                                <Form.Control 
                                                    type="number" 
                                                    name="quantity" 
                                                    min="1" 
                                                    value={form.quantity} 
                                                    onChange={(e) => {
                                                        let val = e.target.value;
                                                        if (val !== "") {
                                                            val = Math.max(1, parseInt(val) || 1);
                                                        }
                                                        handleChange({ target: { name: "quantity", value: val } });
                                                    }}
                                                    onKeyDown={(e) => {
                                                        if (e.key === '-' || e.key === '+' || e.key === 'e' || e.key === '.') {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                    placeholder="Enter purchase quantity"
                                                    required 
                                                />
                                            </Form.Group>
                                        </div>
                                    </Col>
                               <Col xs={12} md={6} lg={4} xxl={3}>
                                        <div className="commonInput">
                                            <Form.Group>
                                                <Form.Label>Remarks</Form.Label>
                                                <Form.Control as="textarea" rows={1} name="remarks" value={form.remarks} onChange={handleChange} />
                                            </Form.Group>
                                        </div>
                                    </Col>
                                </Row>

                                <div className="d-flex justify-content-between mt-3">
                                    <div>
                                        <Button
                                            type="button"
                                            variant="primary"
                                            className="btn-info clearBtn"
                                            onClick={() => setForm({
                                                purchase_no: `PUR-${Date.now()}`,
                                                purchase_date: new Date().toISOString().split('T')[0],
                                                item_id: "",
                                                quantity: "",
                                                remarks: ""
                                            })}
                                        >
                                            Reset
                                        </Button>
                                    </div>
                                    <div>
                                        <Button
                                            type="button"
                                            variant="primary"
                                            className="btn-danger secondaryBtn me-2"
                                            onClick={() => navigate("/purchaselist")}
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            type="submit"
                                            variant="primary"
                                            className="btn-success primaryBtn"
                                        >
                                            Submit
                                        </Button>
                                    </div>
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                </div>
            </Container>
        </div>
    );
};

export default PurchaseEntry;
